import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import RoleControlled from '../../_common/RoleControlled'

import { toggleVisibility, showToast } from '../../../actions'
import { URL } from '../../../const'

import ManualItem from './ManualItem'
import AddManual from './AddManual'
import Loader from '../../_common/Loader'

export class Manuals extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
      addingNewManual: false,
      show_panel: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }

  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}manuals/${this.props.propertyID}`
    try {
      const res = await axios.get(
        url,
        config
      )
      const data = res.data.manuals
      this.setState({ data, loading: false, show_panel: res.data.show })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }
  _handleEnablePanel (e) {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 1, e.target.checked)
  }

  _handleAddClick () {
    this.setState({ addingNewManual: true })
  }
  _handleCancelClick () {
    this.setState({ addingNewManual: false })
  }

  async _handleSaveManual (callback, data, pdf) {
    // console.log('saving data...', data, pdf)
    // const auth = {
    //   token: this.props.user.token,
    //   userID: this.props.user.userID
    // }
    const url = `${URL}manuals/${this.props.propertyID}`
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Token ${this.props.user.token}`
      }
    }

    try {
      const json = JSON.stringify(data)

      const formData = new FormData()
      formData.append('data', json)
      // console.log('form data: ', json)
      if (pdf) {
        formData.append('file', pdf, `manual-${data.id || '000'}-${Date.now()}.pdf`)
      }
      await axios.post(
        url,
        formData,
        config
      )
      // console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
      callback()
    } catch (error) {
      // console.warn(error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }

  async _handleCreateManual (data, pdf) {
    console.log('creating data...', data, pdf)
    // const auth = {
    //   token: this.props.user.token,
    //   userID: this.props.user.userID
    // }
    const url = `${URL}manuals/${this.props.propertyID}`
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Token ${this.props.user.token}`
      }
    }

    try {
      const json = JSON.stringify(data)

      const formData = new FormData()
      formData.append('data', json)

      if (pdf) {
        formData.append('file', pdf, `manual-${data.id || '000'}-${Date.now()}.pdf`)
      }
      // console.log('form data: ', json)
      await axios.post(
        url,
        formData,
        config
      )
      // console.log('post res: ', res)
      this.setState({ addingNewManual: false })

      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      // console.warn(error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }

  async _handleDeleteManual (id) {
    const url = `${URL}manuals?id=${id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.delete(
        url,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('削除しました。', 'danger')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
    }
  }

  _renderMain () {
    return (
      <div className="inner_container flex justify-around">
        { this._renderAddItem() }
        { this._renderList() }
      </div>
    )
  }

  _renderAddItem () {
    if (this.state.addingNewManual) {
      return <AddManual saveData={this._handleCreateManual.bind(this)} cancel={this._handleCancelClick.bind(this)}/>
    }
    return null
  }

  _renderList () {
    return this.state.data.map(item => {
      return (
        <ManualItem
          manual={item}
          key={item.manual_id}
          role={this.props.user.user_role}
          saveData={this._handleSaveManual.bind(this)}
          deleteData={this._handleDeleteManual.bind(this)}
        />
      )
    })
  }
  _renderLoader () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle small"/>
    }
    return null
  }
  render () {
    if (this.props.activeDetails.data.owner_id === 1) { return null }
    return (
      <div>
        <h4 className="page_title bold flex justify-between">
          <div className="title flex">
            <span>取説・PDFアップロード</span>
            { this._renderLoader() }
          </div>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input type="checkbox" id="showSwitch" className="switch-input" key="checkbox" onChange={this._handleEnablePanel.bind(this)} checked={this.state.show_panel}/>
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? (
              <div>
                <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
                  <div className="add_btn_container flex">
                    <button className="btn primary small_btn flex align-center" onClick={this._handleAddClick.bind(this)}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                      <span>追加</span>
                    </button>
                  </div>
                </RoleControlled>

                <div className="list_container">
                  {
                    this.state.loading
                      ? <Loader classname="loader_dot_circle"/>
                      : this._renderMain()
                  }
                </div>
              </div>
            )
            : null
        }
      </div>
    )
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { toggleVisibility, showToast })(Manuals)



// WEBPACK FOOTER //
// ./src/components/Properties/Manuals/index.js